import Request from '@/core/QuRequest';

const req = new Request();

export default {
  methods: {
    // 获取列表参数
    getListParams() {
      const [filtersMin, filtersMax] = this.handleFilters(this.filter);

      const params = {
        page: this.page,
        page_size: this.page_size,
        fields: this.field.join(','),
        dimension: this.handleDimensions(),
        needStringify: true,
        token: this.$store.state.token,
        start_date: this.startDate,
        end_date: this.endDate,
        filters_min: filtersMin,
        filters_max: filtersMax,
      };

      if (this.regionId) {
        params.region_id = this.regionId;
      }

      if (this.saleId) {
        params.sale_id = this.saleId;
      }

      if (this.order) {
        params.order = this.order;
      }

      return params;
    },

    // 获取列表数据
    async getList() {
      const params = this.getListParams();

      try {
        const res = await req.send(req.Apis.sales.report.channelList, params);
        this.dataSource = this.formatTableData(res.data.data);
        this.dataSourceSum = res.data.sum_data || {};
        this.total = res.data.total;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取大区数据
    async getRegions() {
      try {
        const res = await req.send(req.Apis.sales.report.channelStructureList);
        this.region = this.handleRegions(res.data);
      } catch (err) {
        this.$message.error(
          `获取渠道组织架构失败：${err.message || '未知错误'}`,
        );
      }
    },

    // 获取趋势分析数据
    async getTrendAnalysisData() {
      const params = {
        dimension: this.handleDimensionsChart(),
        start_date: this.startDate,
        end_date: this.endDate,
        fields: this.trendAnalysisDefaultTargets.join(','),
        needStringify: true,
      };

      if (this.regionId) {
        params.region_id = this.regionId;
      }

      if (this.saleId) {
        params.sale_id = this.saleId;
      }

      if (this.compStartDate) {
        params.comp_start_date = this.compStartDate;
      }

      if (this.compEndDate) {
        params.comp_end_date = this.compEndDate;
      }

      try {
        const res = await req.send(req.Apis.sales.report.channelChart, params);
        this.trendAnalysisDataSource = res.data || {};
      } catch (err) {
        this.$message.error(`获取图表数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取对比分析数据
    async getProportionAnalysisData() {
      const params = {
        dimension: this.proportionAnalysisDimension,
        start_date: this.startDate,
        end_date: this.endDate,
        fields: this.proportionAnalysisTarget,
        needStringify: true,
      };
      try {
        const res = await req.send(
          req.Apis.sales.report.venusReportPie,
          params,
        );
        this.proportionAnalysisDataSource = res.data;
      } catch (err) {
        this.$message.error(`获取饼图数据失败：${err.message || '未知错误'}`);
      }
    },
  },
};
